import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  order: 5;
  .blob {
    background: ${({ color }) => color};
    border-radius: 50%;
    margin: 0 10px;
    height: 10px;
    width: 10px;
  }
`;

function ClassStatus({ state, color, show }) {
  return (
    <Container color={color}>
      {show ? <span className="blob"></span> : null}
      {state}
    </Container>
  );
}

export default ClassStatus;
